import RequestAbstract from "../abstract";

export default class MerchantFiles extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/merchant-files";
    }
}
